import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { NgIf } from '@angular/common';
import { LeagueWeek } from '../../../models/LeagueWeek';
import { GolfEvent } from '../../../models/GolfEvent';
import { ApplicationService } from '../../../services/application.service';

@Component({
  selector: 'app-week-details',
  standalone: true,
  imports: [NgIf],
  templateUrl: './week-details.component.html',
  styleUrl: './week-details.component.css'
})
export class WeekDetailsComponent implements OnChanges {
  @Input() leagueWeek:LeagueWeek|null = null;
  @Input() league:GolfEvent|null = null;
  @Input() canEdit:boolean = false;
  @Output() edit = new EventEmitter<void>();

  constructor(private applicationService:ApplicationService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['leagueWeek'] && changes['leagueWeek'].currentValue) {
      
    }
  }

  get editLabel():string {
    const isLeagueWeek = !this.league?.type
      || this.league.type === 'MULTI_WEEK_LEAGUE'
      || this.league.type === 'LEAGUE';
    return isLeagueWeek ? 'Edit Week' : 'Edit Course';
  }

  formatYesNo(value:boolean|undefined) {
    if(value === undefined || !value)
      return 'No';
    else
      return 'Yes';
  }

  formatDate(date: string | Date | undefined): string {
    return this.applicationService.formatUTCDate(date);
  }

  formatHolesToPlay(holesToPlay:string|undefined) {
    if(!holesToPlay)
      return '';

    return this.applicationService.formatHolesToPlay(holesToPlay);
  }
}
